module.exports = __webpack_public_path__ + "static/img/s3.41155d9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/custom/s3.png
// module id = gPKZ
// module chunks = 0